import { IPricingRecordLineItem } from "@services/QuoteBuilder/QuoteBuilderService";

/**
 * This function is used only for Onboarding v2 wherein a subscription price
 * consists of many components such as a plan, addons, and coupons.
 * @param pricingRecordLineItems This is an array of pricing record line items
 * @returns 
 */
export const getTotalWeeklySubscriptionPrice = (
  pricingRecordLineItems: IPricingRecordLineItem[]
) => {
  // Calculates the total of all included items - including GST/VAT
  const includedItems = pricingRecordLineItems.filter((item) => item.included);
  const totalWeeklySubscriptionPrice = includedItems.reduce(
    (sum, item) => sum + item.price_including_gst,
    0
  );
  return totalWeeklySubscriptionPrice;
};

/**
 * This function is used only for Onboarding v2 to get the plan weekly fee.
 * Useful for displaying the plan fee separately from addons and coupons,
 * such as in Flexi Try Ignition.
 * @param pricingRecordLineItems This is an array of pricing record line items
 * @returns 
 */
export const getPlanWeeklyFee = (
    pricingRecordLineItems: IPricingRecordLineItem[]
) => {
    // Retrieve the plan item from the line items
    const planItem = pricingRecordLineItems.find(
        (item) =>
            item.chargebee_item_type === "Plan" && item.included === true
    );
    return planItem ? planItem.price_including_gst : 0;
};


/**
 * This function is used only for Onboarding v2 to get a list of included
 * coupons.
 * @param pricingRecordLineItems This is an array of pricing record line items
 * @returns An array of all included coupon line items
 */
export const getCoupons = (
  pricingRecordLineItems: IPricingRecordLineItem[]
): IPricingRecordLineItem[] => {
  // Retrieve all coupon_ids from the line items
  const coupons = pricingRecordLineItems.filter(
      (item) =>
          item.chargebee_item_type === "Coupon" && item.included === true
  );
  return coupons;
};


/**
 * This function returns a line item for a particular component
 * @param pricingRecordLineItems This is an array of pricing record line items
 * @param chargebeeComponent This is the component to look for
 * @returns a line item for a specified chargebeeComponent parameter
 */
export const getLineItemByComponent = (
    pricingRecordLineItems: IPricingRecordLineItem[],
    chargebeeComponent: string
) => {
    // Retrieve the plan item from the line items
    const addon = pricingRecordLineItems.find(
        (item) =>
            item.chargebee_component === chargebeeComponent
    );
    return addon
};
